import React from 'react'
import { useTranslation } from 'react-i18next'
import * as S from './styles'

interface StepBarProps {
  currentStep: number
  totalSteps: number
  isFinished: boolean
}

const StepBar: React.FC<StepBarProps> = ({
  currentStep,
  totalSteps,
  isFinished
}) => {
  const { t } = useTranslation()

  const step = Math.max(1, Math.min(currentStep, totalSteps))
  const percent = (step / totalSteps) * 100

  return (
    <>
      <S.Label>
        {t('contactPage.form.step')} {step} {t('contactPage.form.of')}{' '}
        {totalSteps}
      </S.Label>
      <S.BarBackground>
        <S.BarFill percent={percent} isFinished={isFinished} />
      </S.BarBackground>
    </>
  )
}

export default StepBar
